<template>
    <div class="fixed z-50 top-52 right-0 flex">
        <button
            type="button"
            class="h-14 w-14 bg-white border border-r-0 rounded-bl-lg md:rounded-tl-lg"
            @click="show = !show"
        >
            <span class="flex h-full flex-col justify-center items-center">
                <svg v-if="!show" width="22" height="22" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </span>
        </button>
        <div v-if="show" class="bg-white w-72 rounded-bl-lg p-3">
          <div v-if="reordering" class="flex justify-center items-center">
            <spinning-circle />
          </div>
          <vue-draggable-next
              v-else
            class="mt-3"
            :list="store.proposal.places"
            @end="onEnd"
          >
            <div
              class="list-group-item bg-gray-300 m-1 p-3 rounded-md flex cursor-move"
              v-for="(element, index) in store.proposal.places"
              :key="element.name"
            >
              <p class="text-center flex-1">
                {{ element.name }}</p>
              <span class="cursor-pointer" @click="remove(element, index)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </span>
            </div>
            <div @click="showAddModal = true" class="list-group-item bg-green-300 m-1 p-3 rounded-md flex cursor-pointer justify-center">
              <span>Add destination</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
              </svg>
            </div>

          </vue-draggable-next>
        </div>
      <alert-modal
        v-if="toRemove"
        title="title"
        message="message"
        type="type"
        :show="toRemove !== null"
        @close="toRemove = null"
      >
        <div v-if="!deleting" class="flex flex-col space-y-5">
          <h3 class="text-lg font-semibold">Are you sure you want to remove {{ toRemove.destination.name }} from destinations?</h3>
          <p>Lodging, eateries and activities will be removed. This action can not be undone.</p>
        </div>

        <spinning-circle v-else class="mx-auto" />

        <template #buttons>
          <template v-if="!deleting">
            <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                @click="deleteDestination"
            >
              Remove
            </button>
            <button
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                @click="toRemove = null"
            >
              Cancel
            </button>
          </template>
          <div v-else class="w-full text-center">
            Deleting...
          </div>
        </template>
      </alert-modal>

      <small-modal
        v-if="showAddModal"
        title="Add destination"
        :show="showAddModal"
        @close="showAddModal = false">
        <div class="flex flex-col space-y-5">
          <h3 class="text-xl font-semibold">Add destination</h3>
          <destination-select-picker
            v-model="destinationToAdd"
          />
          <div class="flex flex-row-reverse">
            <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-button-purple sm:ml-3 sm:w-auto sm:text-sm"
                @click="addDestination"
                :class="destinationToAdd ? 'cursor-pointer bg-button-purple' : 'cursor-not-allowed disabled bg-gray-300 hover:bg-gray-300'"
                :disabled="!destinationToAdd"
            >
              Add
            </button>
            <button
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                @click="close"
            >
              Cancel
            </button>
          </div>
        </div>

      </small-modal>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import {useProposalOldStore} from "@/Stores/ProposalOld";
import { VueDraggableNext } from 'vue-draggable-next'
import AlertModal from "@/ComponentsDeprecated/Modal/AlertModal";
import SpinningCircle from "@/ComponentsDeprecated/Loaders/SpinningCircle";
import SmallModal from "@/ComponentsDeprecated/Modal/SmallModal";
import DestinationSelectPicker from "@/ComponentsDeprecated/Select/DestinationSelectPicker";

const toRemove = ref(null)
const show = ref(false)
const showAddModal = ref(false)
const destinationToAdd = ref(null)
const store = useProposalOldStore()
const deleting = ref(false)
const reordering = ref(false)

function onEnd() {
  reordering.value = true
  const places = store.proposal.places;
  // We need to empty out the array and re-populate to
  // trigger a re-render of each destination component
  store.proposal.places = [];
  // And we need to add a small timer to allow the DOM
  // to clear
  setTimeout(() => {
    places.forEach((place, index) => {
      places[index].pivot.order = index
    })
    store.proposal.places = places;
    reordering.value = false
  }, 100);
}

function remove(destination, index) {
  toRemove.value = {destination, index}
}

function deleteDestination() {
  deleting.value = true
  axios.delete(route('api.proposal.place.destroy', {proposal: store.proposal.id, proposalPlace: toRemove.value.destination.pivot.id})).then(
      () => {}
  ).finally(() => {
    store.proposal.places.splice(toRemove.value.index, 1)
    toRemove.value = null
    deleting.value = false
    show.value = false
  })
}

function addDestination() {
  axios.post(route('api.proposal.place.add', {proposal: store.proposal.id}), {place_id: destinationToAdd.value.id}).then((response) => {
    store.proposal.places = response.data
    showAddModal.value = false
    show.value = false
  })
}

</script>
